import { useHistory } from 'react-router-dom';
import l from '../../../../lang';
import IntegrationCard from '../integration-card';
import { ReactComponent as ApiIcon } from '../../../../assets/icons/api.svg';
import { segmentIntegrationsMenuApiIntegration } from '../../../../utils/analytics';
import { Routes } from '../../../../config/routes';

export default () => {
  const history = useHistory();

  return (
    <IntegrationCard
      title={l('paymentIntegration.api.title')}
      icon={<ApiIcon />}
      color="blue"
      onDetails={() => {
        segmentIntegrationsMenuApiIntegration();
        history.push(`${Routes.PAYMENT_INTEGRATION}?details=API`);
      }}
      detailsText={l('paymentIntegration.card.link')}
    />
  );
};
